import { useQuery } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import { IMetaCampaignDetail } from "../../features/Campaigns/interface/metaAds";
import { useAuth } from "../helper/useAuth";

interface UseMetaAdsCampaignDetailProps {
  campaign_id: string;
  startDate: string;
  endDate: string;
  enabled?: boolean;
}

export const useMetaAdsCampaignDetail = ({
  campaign_id,
  startDate,
  endDate,
  enabled = true,
}: UseMetaAdsCampaignDetailProps) => {
  const { selectedIntegration } = useAuth();

  return useQuery<IMetaCampaignDetail, Error>({
    queryKey: [
      "metaAdsCampaignDetail",
      campaign_id,
      startDate,
      endDate,
      selectedIntegration?.value,
    ],
    queryFn: async () => {
      const url = API_CONFIG.path.metaAdsCampaignDetail.replace(
        ":id",
        campaign_id,
      );
      return httpService.get<IMetaCampaignDetail>(url, {
        start_date: startDate,
        end_date: endDate,
        tracking_id: selectedIntegration?.value as string,
      });
    },
    enabled: !!campaign_id && !!selectedIntegration?.value && enabled,
    staleTime: 5 * 60 * 1000,
  });
};
